import * as React from 'react';

var Facebook = function (_a) {
    var _b = _a.idSuffix, idSuffix = _b === void 0 ? '' : _b;
    return (React.createElement("svg", { "aria-labelledby": "facebook-icon-".concat(idSuffix), height: "40", role: "img", viewBox: "0 0 40 40", width: "40", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", { id: "facebook-icon-".concat(idSuffix) }, "Invitae's Facebook Page"),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "m24.28 21.25.57-3.62h-3.567v-2.348c0-.99.498-1.956 2.096-1.956h1.621v-3.081s-1.471-.245-2.878-.245c-2.937 0-4.857 1.734-4.857 4.872v2.758h-3.265v3.62h3.265v8.75h4.018v-8.75h2.996z", fill: "#161616", fillRule: "nonzero" }))));
};

export { Facebook as default };
//# sourceMappingURL=Facebook.esm.js.map
